<template>
    <div>
        <b-card>
            <b-row>
                <b-col sm="12" class="text-right">
                    <b-btn-group size="sm">
                        <b-button variant="white" class="button-icon-only mr-1" title="Обновить"
                                  @click="buttonRefreshClicked"
                        >
                            <i class="fa fa-sync"/>
                        </b-button>
                        <b-dropdown v-show="userActionAccessArray['new']" right text="Новая запись" variant="success">
                            <b-dropdown-item v-for="item in registrationTypes" v-bind:key="item.UID"
                                             @click="buttonAddClicked(item.UID)"
                            >
                                {{item.RegistrationType}}
                            </b-dropdown-item>
                        </b-dropdown>
                    </b-btn-group>
                </b-col>
            </b-row>
            <MyToolbar>
                <MyToolbarItem>
                    <b-input v-model="searchParams.searchQuickFilter" @keyup.prevent.enter="buttonSearchClicked"
                             maxlength="200"
                             size="sm" placeholder="Поиск..." ref="inputQuickFilter"
                             @keyup.esc="searchParams.searchQuickFilter=''"
                             :disabled="searchParams.sortMode!==0"
                    />
                </MyToolbarItem>
                <MyToolbarItem>
                    <b-input-group>
                        <b-input-group-prepend>
                            <label for="input-start-dt" class="mt-2">Дата:</label>
                        </b-input-group-prepend>
                        <b-input id="input-start-dt" v-model="searchParams.searchStartDt" @change="buttonSearchClicked"
                                 :disabled="searchParams.sortMode!==0"
                                 style="margin-left:10px;width:140px" size="sm" type="date"
                        />
                    </b-input-group>
                </MyToolbarItem>
                <MyToolbarItem>
                    <b-input-group>
                        <b-form-checkbox switch size="lg" id="check-search-only-own-registrations" class="ml-1 mt-1"
                                         v-model="searchParams.searchOnlyOwnRegistrations" @change="buttonSearchClicked"
                        />
                        <b-input-group-append>
                            <label for="check-search-only-own-registrations" class="mt-2">
                                Только свои регистрации
                            </label>
                        </b-input-group-append>
                    </b-input-group>
                </MyToolbarItem>
                <MyToolbarItem>
                    <b-button size="sm" variant="secondary" @click="buttonSearchClicked">Поиск</b-button>
                    <b-button size="sm" :variant="searchParams.sortMode===0 ? 'secondary' : 'primary'"
                              title="Расширенный поиск"
                              class="button-icon-only-normal ml-2"
                              @click="buttonAdvSearchShowClicked"
                    >
                        <i class="fas fa-cog"/>
                    </b-button>
                </MyToolbarItem>
                <MyToolbarItem>
                    <b-dropdown size="sm" :text="searchParams.searchPatternName" variant="light"
                                title="Шаблоны поиска" style="min-width: 150px;"
                    >
                        <b-dropdown-item v-for="item in searchParams.searchPatterns" v-bind:key="item.PatternName"
                                         @click.stop="searchPatternsClicked(item)"
                                         :class="(item.PatternName==='Сбросить') ? 'reset-dropdown-item' : '' "
                        >
                            {{item.PatternName}}
                        </b-dropdown-item>
                    </b-dropdown>
                </MyToolbarItem>
            </MyToolbar>

            <b-alert :show="err" :variant="errVariant" class="mb-4">{{errText}}</b-alert>

            <b-table outlined hover head-variant="light" :fields="subscriberListFields" :items="subscriberList"
                     responsive="responsive" :no-local-sorting="true" sort-by="DT" sort-desc
                     @row-clicked="tableRowClicked"
                     @sort-changed="sortChanged"
            >
            </b-table>
            <b-row>
                <b-col sm="6">
                    <b-pagination first-number last-number
                                  v-model="recordCurrentPageNumber" @input="loadRegistrationList"
                                  :total-rows="recordTotalNumber" :per-page="recordCountPerPage"
                    />
                </b-col>
                <b-col sm="6">
                    <div class="custom-items-per-page-div">
                        <label>Показать записей:</label>
                        <b-form-select id="input-records-per-page" size="sm" style="margin-left: 10px;width:65px"
                                       :options="recordCountPerPageArray" v-model="recordCountPerPage"
                                       @change="loadRegistrationList"
                        />
                    </div>
                </b-col>
            </b-row>

        </b-card>

        <b-modal ref="modal-search" hide-footer centered title="Расширенный поиск" @hidden="modalHidden">
            <b-alert :show="errModal" :variant="errVariantModal" class="mb-4">{{errTextModal}}</b-alert>
            <b-row>
                <b-col sm="12" v-if="userActionAccessCompany">
                    <b-form-group label="РЭК" label-for="input-AdvSearch-company">
                        <b-select id="input-AdvSearch-company" :options="searchParams.searchCompanies"
                                  v-model="searchParams.searchCompanyUid" autofocus
                                  @change="loadRes"
                        />
                    </b-form-group>
                </b-col>
                <b-col sm="12" v-if="userActionAccessRes">
                    <b-form-group label="РЭС" label-for="input-AdvSearch-res">
                        <b-select id="input-AdvSearch-res" :options="searchParams.searchRes"
                                  v-model="searchParams.searchResUid"
                                  :disabled="searchParams.searchCompanyUid===0 && userActionAccessCompany"
                        />
                    </b-form-group>
                </b-col>
                <b-col sm="6">
                    <b-form-group label="Дата начала" label-for="input-AdvSearch-start-dt">
                        <b-input id="input-AdvSearch-start-dt" v-model="searchParams.searchStartDt" type="date"/>
                    </b-form-group>
                </b-col>
                <b-col sm="6">
                    <b-form-group label="Дата окончания" label-for="input-AdvSearch-end-dt">
                        <b-input id="input-AdvSearch-end-dt" v-model="searchParams.searchEndDt" type="date"/>
                    </b-form-group>
                </b-col>
                <b-col sm="6">
                    <b-form-group label="№ регистрации" label-for="input-AdvSearch-registration-num">
                        <b-input id="input-AdvSearch-registration-num" v-model="searchParams.searchRegistrationNum"
                                 @keyup.enter="buttonAdvSearchOkClicked"
                        />
                    </b-form-group>
                </b-col>
                <b-col sm="6">
                    <b-form-group label="Тип регистрации" label-for="select-AdvSearch-registration-type">
                        <b-select id="select-AdvSearch-registration-type"
                                  :options="searchParams.searchRegistrationTypes"
                                  v-model="searchParams.searchRegistrationTypeUid"
                        />
                    </b-form-group>
                </b-col>
                <b-col sm="6">
                    <b-form-group label="Абонент" label-for="input-AdvSearch-subscriber">
                        <b-input id="input-AdvSearch-subscriber" v-model="searchParams.searchSubscriber"
                                 @keyup.enter="buttonAdvSearchOkClicked"
                        />
                    </b-form-group>
                </b-col>
                <b-col sm="6">
                    <b-form-group label="Телефон" label-for="input-AdvSearch-phone-number">
                        <b-input id="input-AdvSearch-phone-number" v-model="searchParams.searchPhoneNumber"
                                 @keyup.enter="buttonAdvSearchOkClicked"
                        />
                    </b-form-group>
                </b-col>
                <b-col sm="12">
                    <b-form-group label="Адрес" label-for="input-AdvSearch-address">
                        <b-input id="input-AdvSearch-address" v-model="searchParams.searchAddress"
                                 @keyup.enter="buttonAdvSearchOkClicked"
                        />
                    </b-form-group>
                </b-col>
                <b-col sm="6">
                    <b-form-group label="Статус регистрации" label-for="input-AdvSearch-record-status">
                        <b-select id="input-AdvSearch-record-status" :options="searchParams.searchRegistrationStatuses"
                                  v-model="searchParams.searchRegistrationStatusUid"
                        />
                    </b-form-group>
                </b-col>
                <b-col sm="6">
                    <b-form-group label="Только свои регистрации" label-for="check-AdvSearch-only-own-registrations">
                        <b-form-checkbox switch size="lg" id="check-AdvSearch-only-own-registrations" class="mt-2"
                                         v-model="searchParams.searchOnlyOwnRegistrations"
                        />
                    </b-form-group>
                </b-col>
            </b-row>
            <div>
                <b-button variant="outline-danger" @click="buttonAdvSearchCancelClicked">Сбросить</b-button>
                <b-button variant="secondary" class="ml-2 float-right" @click="buttonAdvSearchCloseClicked">Закрыть
                </b-button>
                <b-button variant="primary" class="float-right" @click="buttonAdvSearchOkClicked">Поиск</b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
    import MyToolbar from "@/view/components/MyToolbar";
    import MyToolbarItem from "@/view/components/MyToolbarItem";
    import axios from "axios";

    export default {
        name: "NewSubscriber",
        components: {MyToolbar, MyToolbarItem},
        data() {
            return {
                userData: this.$store.getters.getUserData,
                recordCountPerPageArray: this.$store.getters.getRecordCountPerPageArray || [],
                recordCountPerPage: this.$store.getters.getRecordCountPerPage || 20,
                recordCurrentPageNumber: 1,
                recordTotalNumber: 0,

                userActionAccessArray: [],
                userActionAccessCompany: false,
                userActionAccessRes: false,

                loadProcessing: 0,

                err: false,
                errText: "",
                errVariant: "danger",

                errModal: false,
                errTextModal: "",
                errVariantModal: "danger",

                searchParams: {
                    sortMode: 0,    //0-simple, 1-advanced

                    searchQuickFilter: "",
                    searchRegistrationStatusUid: -1,
                    searchCompanyUid: 0,
                    searchResUid: "",
                    searchStartDt: new Date().toISOString().substr(0, 10),
                    searchEndDt: new Date().toISOString().substr(0, 10),
                    searchOnlyOwnRegistrations: false,
                    searchRegistrationNum: "",
                    searchRegistrationTypeUid: -1,
                    searchSubscriber: "",
                    searchPhoneNumber: "",
                    searchAddress: "",
                    searchPatternUid: "",

                    searchRegistrationStatuses: [],
                    searchCompanies: [],
                    searchRes: [{'value': '', 'text': '<все>'}],
                    searchRegistrationTypes: [],
                    searchPatterns: [],
                    searchPatternName: "Шаблоны поиска",
                },

                sortBy: "DT",
                sortDesc: true,

                registrationTypes: [],
                registrationTypeUid: -1,

                subscriberList: [],
                subscriberListFields: [
                    {key: "RowNumber", label: "№", tdClass: "pointer"},
                    {key: "CompanyAlias", label: "РЭК", sortable: true, tdClass: "pointer"},
                    {key: "RES", label: "РЭС", sortable: true, tdClass: "pointer"},
                    {key: "DT", label: "Дата", sortable: true, tdClass: "pointer"},
                    {key: "RegistrationNum", label: "Номер", sortable: true, tdClass: "pointer"},
                    {key: "Subscriber", label: "Абонент", sortable: true, tdClass: "pointer"},
                    {key: "Address", label: "Адрес", tdClass: "pointer"},
                    {key: "PhoneNumbers", label: "Телефон(ы)", tdClass: "pointer"},
                    {key: "RegistrationType", label: "Вид регистрации", sortable: true, tdClass: "pointer"},
                    {key: "RegistrationStatus", label: "Статус", sortable: true, tdClass: "pointer"},
                ],
            }
        },
        created() {
            this.userActionAccessArray = this.getUserActionAccessArray("DocsNewSubscriber", this.userData.UserAccess)
            this.userActionAccessCompany = this.getUserDataAccess("RefsCompanies", this.userData.UserAccess)
            this.userActionAccessRes = this.getUserDataAccess("RefsRES", this.userData.UserAccess)

            if (this.userActionAccessArray['new']) this.searchParams.searchOnlyOwnRegistrations = true
        },
        mounted() {
            this.$store.dispatch(SET_BREADCRUMB, [
                {title: "Документы", route: "new-subscriber"},
                {title: "Новый абонент"}
            ]);

            let returnFromUpdate = this.$route.query.returnFromUpdate || false
            if (returnFromUpdate) {
                //Если возвращается из режима редактирования
                let sp = this.$store.getters.getNewSubscriberSearchParams
                if (!this.isObjectEmpty(sp)) {
                    this.searchParams = sp
                } else {
                    returnFromUpdate = false
                }
                this.$store.commit('set', ["newSubscriberSearchParams", {}])
            }

            if (!returnFromUpdate) {
                //Иначе грузимся как обычно
                this.loadSearchRegistrationTypes()
                this.loadRegistrationStatuses()
                this.loadRes()
                if (this.userData.UserGroupUid === 1) this.loadCompanies()
            }

            this.loadRegistrationTypes()
            this.loadSearchPatterns()
            this.loadRegistrationList()

            //If not Admin - delete Company from the list
            if (this.userData.UserGroupUid !== 1) {
                let ind = this.subscriberListFields.findIndex(item => item.key.toLowerCase() === "companyalias");
                if (ind >= 0)
                    this.subscriberListFields.splice(ind, 1)
            }
            //If no access to Res - delete Res from the list
            if (!this.userActionAccessRes) {
                let ind = this.subscriberListFields.findIndex(item => item.key.toLowerCase() === "res");
                if (ind >= 0)
                    this.subscriberListFields.splice(ind, 1)
            }

            this.$nextTick(() => {
                this.$refs.inputQuickFilter.$el.focus()
            })

        },
        methods: {
            errTextHide() {
                this.err = false
                this.errText = ""
            },
            errTextShow(msg, variant = "danger", withScroll = true) {
                if (withScroll)
                    window.scrollTo(0, 0)
                this.errText = msg
                this.errVariant = variant
                this.err = true
            },
            errTextHideModal() {
                this.errModal = false
                this.errTextModal = ""
            },
            errTextShowModal(msg, variant = "danger", withScroll = true) {
                if (withScroll)
                    window.scrollTo(0, 0)
                this.errTextModal = msg
                this.errVariantModal = variant
                this.errModal = true
            },
            loadCompanies() {
                this.searchParams.searchCompanies = [{'value': 0, 'text': "<все>"}]

                axios.post("/ws/ws.svc/GetRefsCompaniesArray", {
                        'Session_UID': this.userData.Session_UID,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                            if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)
                                || this.isUndefined(resp.data.data)) {
                                this.errTextShow("Неверный формат ответа.")
                            } else {
                                if (resp.data.success) {
                                    if (resp.data.data.toString().length > 0) {
                                        let result = JSON.parse(resp.data.data)
                                        result.data.forEach(item => {
                                            this.searchParams.searchCompanies.push({'value': item.UID, 'text': item.Alias})
                                        })
                                    }
                                } else {
                                    this.errTextShow(resp.data.response.toString())
                                }
                            }
                        }
                    )
                    .catch(err => {
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")")
                    })
            },
            loadRes() {
                this.searchParams.searchResUid = ""
                this.searchParams.searchRes = [{'value': "", 'text': '<все>'}]
                this.errTextHideModal()

                if (!this.userActionAccessRes) return

                this.loadProcessing++
                axios.post("/ws/ws.svc/GetRefsRESArray", {
                        'Session_UID': this.userData.Session_UID,
                        'F_Company_UID': this.searchParams.searchCompanyUid,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                            if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)
                                || this.isUndefined(resp.data.data)) {
                                this.errTextShowModal("Неверный формат ответа.")
                            } else {
                                if (resp.data.success) {
                                    if (resp.data.data.toString().length > 0) {
                                        let result = JSON.parse(resp.data.data)
                                        result.forEach(item => {
                                            this.searchParams.searchRes.push({
                                                'value': item.UID,
                                                'text': item.RES
                                            })
                                        })
                                    }
                                } else {
                                    this.errTextShowModal(resp.data.response.toString())
                                }
                            }
                            this.loadProcessing--
                        }
                    )
                    .catch(err => {
                        this.loadProcessing--
                        this.errTextShowModal("Ошибка при получении данных (" + err.message + ")")
                    })
            },
            loadRegistrationTypes() {
                this.searchParams.searchRegistrationTypeUid = -1
                this.searchParams.searchRegistrationTypes = [{'value': -1, 'text': "<все>"}]
                this.registrationTypeUid = -1
                this.registrationTypes = []

                axios.post("/ws/ws.svc/GetRefsNewSubscriberRegistrationTypesArray", {
                        'Session_UID': this.userData.Session_UID,
                        'F_Company_UID': this.searchParams.searchCompanyUid,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                            if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)
                                || this.isUndefined(resp.data.data)) {
                                this.errTextShow("Неверный формат ответа.")
                            } else {
                                if (resp.data.success) {
                                    if (resp.data.data.toString().length > 0) {
                                        let result = JSON.parse(resp.data.data)
                                        this.registrationTypes = result
                                        result.forEach(item => {
                                            this.searchParams.searchRegistrationTypes.push({
                                                'value': item.UID,
                                                'text': item.RegistrationType
                                            })
                                        })
                                    }
                                } else {
                                    this.errTextShow(resp.data.response.toString())
                                }
                            }
                        }
                    )
                    .catch(err => {
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")")
                    })
            },
            loadSearchPatterns() {
                this.searchParams.searchPatternUid = ""
                this.searchParams.searchPatterns = []

                axios.post("/ws/ws.svc/GetRefsNewSubscriberRegistrationSearchPatterns", {
                        'Session_UID': this.userData.Session_UID,
                        'F_Company_UID': this.searchParams.searchCompanyUid,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                            if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)
                                || this.isUndefined(resp.data.data)) {
                                this.errTextShow("Неверный формат ответа.")
                            } else {
                                if (resp.data.success) {
                                    if (resp.data.data.toString().length > 0) {
                                        this.searchParams.searchPatterns = JSON.parse(resp.data.data)
                                    }
                                } else {
                                    this.errTextShow(resp.data.response.toString())
                                }
                            }
                            this.searchParams.searchPatterns.push({PatternName: "Сбросить", SearchParamsJson: {}})
                        }
                    )
                    .catch(err => {
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")")
                    })
            },
            loadSearchRegistrationTypes() {
                this.searchParams.searchRegistrationTypeUid = -1
                this.searchParams.searchRegistrationTypes = [{'value': -1, 'text': "<все>"}]

                axios.post("/ws/ws.svc/GetRefsNewSubscriberRegistrationTypesArray", {
                        'Session_UID': this.userData.Session_UID,
                        'F_Company_UID': this.searchParams.searchCompanyUid,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                            if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)
                                || this.isUndefined(resp.data.data)) {
                                this.errTextShow("Неверный формат ответа.")
                            } else {
                                if (resp.data.success) {
                                    if (resp.data.data.toString().length > 0) {
                                        let result = JSON.parse(resp.data.data)
                                        result.forEach(item => {
                                            this.searchParams.searchRegistrationTypes.push({
                                                'value': item.UID,
                                                'text': item.RegistrationType
                                            })
                                        })
                                    }
                                } else {
                                    this.errTextShow(resp.data.response.toString())
                                }
                            }
                        }
                    )
                    .catch(err => {
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")")
                    })
            },
            loadRegistrationStatuses() {
                this.searchParams.searchRegistrationStatusUid = -1
                this.searchParams.searchRegistrationStatuses = [{'value': -1, 'text': "<все>"}]

                axios.post("/ws/ws.svc/GetRefsNewSubscriberRegistrationStatusesArray", {
                        'Session_UID': this.userData.Session_UID,
                        'F_Company_UID': this.searchParams.searchCompanyUid,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                            if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response)
                                || this.isUndefined(resp.data.data)) {
                                this.errTextShow("Неверный формат ответа.")
                            } else {
                                if (resp.data.success) {
                                    if (resp.data.data.toString().length > 0) {
                                        let result = JSON.parse(resp.data.data)
                                        result.forEach(item => {
                                            this.searchParams.searchRegistrationStatuses.push({
                                                'value': item.UID,
                                                'text': item.Status
                                            })
                                        })
                                    }
                                } else {
                                    this.errTextShow(resp.data.response.toString())
                                }
                            }
                        }
                    )
                    .catch(err => {
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")")
                    })
            },
            loadRegistrationList() {
                this.errTextHide()

                if (this.isUndefined(this.searchParams.searchStartDt) || this.searchParams.searchStartDt === "") {
                    this.errTextShow("Введите дату начала.", "info", true)
                    return
                }
                if (this.searchParams.sortMode === 0) {
                    this.searchParams.searchEndDt = this.searchParams.searchStartDt
                }
                if (this.isUndefined(this.searchParams.searchEndDt) || this.searchParams.searchEndDt === "") {
                    this.errTextShow("Введите дату окончания.", "info", true)
                    return
                }
                if (this.searchParams.searchStartDt > this.searchParams.searchEndDt) {
                    this.errTextShow("Дата начала не может быть позднее даты окончания.", "info", true)
                    return
                }

                this.loadProcessing++
                axios.post("/ws/ws.svc/GetDocsNewSubscriberRegistrations", {
                        'Session_UID': this.userData.Session_UID,
                        'Page': this.recordCurrentPageNumber,
                        'RecordsPerPage': this.recordCountPerPage,
                        'SortField': this.sortBy,
                        'SortMode': (this.sortDesc ? 1 : 0),
                        'F_Company_UID': this.searchParams.searchCompanyUid,
                        'F_RES_UID': this.searchParams.searchResUid,
                        'F_QuickFilter': this.searchParams.searchQuickFilter,
                        'F_DT1': this.getFormatDate(this.searchParams.searchStartDt, "DD.MM.yyyy"),
                        'F_DT2': this.getFormatDate(this.searchParams.searchEndDt, "DD.MM.yyyy"),
                        'F_RegistrationNum': this.searchParams.searchRegistrationNum,
                        'F_RegistrationType_UID': this.searchParams.searchRegistrationTypeUid,
                        'F_Subscriber': this.searchParams.searchSubscriber,
                        'F_PhoneNumber': this.searchParams.searchPhoneNumber,
                        'F_Address': this.searchParams.searchAddress,
                        'F_OnlyOwnRegistrations': (this.searchParams.searchOnlyOwnRegistrations) ? 1 : 0,
                        'F_RS': this.searchParams.searchRegistrationStatusUid,
                    },
                    {headers: {"Content-Type": "application/json"}}
                )
                    .then(resp => {
                        if (this.isUndefined(resp.data.success) || this.isUndefined(resp.data.response) ||
                            this.isUndefined(resp.data.data) || this.isUndefined(resp.data.meta)) {
                            this.errTextShow("Неверный формат ответа.", "danger", true)
                        } else {
                            if (resp.data.success) {
                                if (resp.data.data.toString().length > 0) {
                                    this.subscriberList = JSON.parse(resp.data.data)
                                    if (!this.isUndefined(resp.data.meta.TotalRecordsAmount)) {
                                        this.recordTotalNumber = resp.data.meta.TotalRecordsAmount
                                    } else {
                                        this.errTextShow("Ошибка при получении общего кол-ва записей.", "danger", true)
                                    }
                                } else {
                                    this.recordTotalNumber = 0
                                    this.subscriberList = []

                                }
                            } else {
                                this.errTextShow(resp.data.response.toString(), "danger", true)
                            }
                        }
                        this.loadProcessing--
                    })
                    .catch(err => {
                        this.errTextShow("Ошибка при получении данных (" + err.message + ")", "danger", true)
                        this.loadProcessing--
                    })
            },

            sortChanged(e) {
                this.sortBy = e.sortBy
                this.sortDesc = e.sortDesc
                this.loadRegistrationList()
            },
            buttonSearchClicked() {
                if (this.searchParams.sortMode === 0)
                    this.searchParams.searchEndDt = this.searchParams.searchStartDt
                this.recordCurrentPageNumber = 1
                this.loadRegistrationList()
            },
            searchPatternsClicked(item) {
                if (!this.isUndefined(item) && !this.isUndefined(item.SearchParamsJson)) {
                    if (item.PatternName === "Сбросить") {
                        this.searchParams.searchPatternName = "Шаблоны поиска"
                        this.buttonAdvSearchCancelClicked()
                    } else {
                        let param = item.SearchParamsJson
                        if (!this.isUndefined(param.F_DT1) && param.F_DT1.toString().length > 0) {
                            this.searchParams.searchStartDt = param.F_DT1.toString()
                        }
                        if (!this.isUndefined(param.F_DT2) && param.F_DT2.toString().length > 0) {
                            this.searchParams.searchEndDt = param.F_DT2.toString()
                        }
                        if (!this.isUndefined(param.RegistrationStatus_UID) && this.isInteger(param.RegistrationStatus_UID)) {
                            this.searchParams.searchRegistrationStatusUid = parseInt(param.RegistrationStatus_UID)
                        }
                        this.searchParams.searchPatternName = item.PatternName
                        this.searchParams.sortMode = 1
                        this.loadRegistrationList()
                    }
                }
            },
            buttonAdvSearchShowClicked() {
                this.errTextHideModal()
                this.$refs['modal-search'].show()
            },
            buttonAdvSearchOkClicked() {
                this.errTextHideModal()

                if (this.isUndefined(this.searchParams.searchStartDt) || this.searchParams.searchStartDt === "") {
                    this.errTextShowModal("Введите дату начала.", "info")
                    return
                }
                if (this.isUndefined(this.searchParams.searchEndDt) || this.searchParams.searchEndDt === "") {
                    this.errTextShowModal("Введите дату окончания.", "info")
                    return
                }
                if (this.searchParams.searchStartDt > this.searchParams.searchEndDt) {
                    this.errTextShowModal("Дата начала не может быть позднее даты окончания.", "info")
                    return
                }

                this.searchParams.sortMode = 1
                this.searchParams.searchQuickFilter = ""
                this.recordCurrentPageNumber = 1
                this.searchParams.searchPatternUid = ""

                this.loadRegistrationList()
                this.$refs['modal-search'].hide()
            },
            buttonAdvSearchCancelClicked() {
                this.searchParams.sortMode = 0
                this.searchParams.searchCompanyUid = 0
                this.searchParams.searchResUid = ""
                this.searchParams.searchStartDt = new Date().toISOString().substr(0, 10)
                this.searchParams.searchRegistrationNum = ""
                this.searchParams.searchSubscriber = ""
                this.searchParams.searchPhoneNumber = ""
                this.searchParams.searchAddress = ""
                this.searchParams.searchRegistrationTypeUid = -1
                this.searchParams.searchRegistrationStatusUid = -1
                this.recordCurrentPageNumber = 1
                this.searchParams.searchPatternUid = ""
                this.$refs['modal-search'].hide()
                this.loadRegistrationList()
            },
            buttonAdvSearchCloseClicked() {
                this.$refs['modal-search'].hide()
            },
            buttonAddClicked(regTypeUid) {
                this.$store.commit('set', ["newSubscriberSearchParams", this.searchParams])

                if (regTypeUid === 0)
                    this.$router.push({name: 'documents-new-subscriber-update-0', query: {uid: ""}});
                else if (regTypeUid === 1)
                    this.$router.push({name: 'documents-new-subscriber-update-1', query: {uid: ""}});
                else if (regTypeUid === 2)
                    this.$router.push({name: 'documents-new-subscriber-update-2', query: {uid: ""}});
            },
            buttonRefreshClicked() {
                this.loadRegistrationList()
            },
            modalHidden() {
                this.$nextTick(() => {
                    this.$refs.inputQuickFilter.$el.focus()
                })
            },
            tableRowClicked(item) {
                this.$store.commit('set', ["newSubscriberSearchParams", this.searchParams])

                if (item.RegistrationType_UID === 0)
                    this.$router.push({name: 'documents-new-subscriber-update-0', query: {uid: item.UID}});
                else if (item.RegistrationType_UID === 1)
                    this.$router.push({name: 'documents-new-subscriber-update-1', query: {uid: item.UID}});
                else if (item.RegistrationType_UID === 2)
                    this.$router.push({name: 'documents-new-subscriber-update-2', query: {uid: item.UID}});
            },
        },
        computed: {
            getEditControlStatus: function () {
                return (!this.userActionAccessArray["edit"])
            },
        },
        watch: {
            loadProcessing: function () {
                this.$store.commit('set', ["showSpinner", this.loadProcessing > 0])
            },
        }
    }
</script>

<style scoped>
    .reset-dropdown-item {
        border-top: #ddd 1px solid;
    }

    /deep/ .reset-dropdown-item a {
        color: #F64E60 !important;
    }
</style>